var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oz-business-type"},[_c('new-l-radio-group',{attrs:{"label":"O que você precisa?","appearance":"primary","options":_vm.businessOptions,"data-cy":"filters-business"},on:{"change":_vm.onChange},model:{value:(_vm.businessValue),callback:function ($$v) {_vm.businessValue=$$v},expression:"businessValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }